import { Helmet } from "react-helmet";
import SolutionItemHero from "../../components/reusables/hero/SolutionItemHero";
import Authority from "../../components/reusables/Authority";
import DigitalMarketing from "../../components/solutions/dmarketing/DigitalMarketing";
import SolutionCTA from "../../components/solutions/SolutionCTA";
import DigitalMarketingFaqsBody from "../../components/faqs/DigitalMarketingFaqsBody";
import HowWeWork from "../../components/solutions/HowWeWork";
import RelatedDigitalMarketing from "../../components/solutions/dmarketing/RelatedDigitalMarketing";

export default function DigitalMark() {
  return (
    <>
      <Helmet>
        <link
          rel="canonical"
          href="https://www.ntuna.com/solutions/digital-marketing-seo"
        />
        <meta
          name="description"
          content="Attract the right audience, convert visitors into customers and grow your brand online with our SEO and digital marketing implementations and strategies"
        />
       
        <meta
          property="og:description"
          content="Attract the right audience, convert visitors into customers and grow your brand online with our SEO and digital marketing implementations and strategies"
        />
        <meta
          property="og:title"
          content="NTUNA.COM | Solutions | Digital Marketing & SEO"
        />
        <meta
          property="og:image"
          content="https://res.cloudinary.com/malidad/image/upload/v1779627082/ntuna_solutions_banner_1200x628_c8xerm.jpg"
        />

        <meta
          name="twitter:title"
          content="NTUNA.COM | Solutions | Digital Marketing & SEO"
        />
        <meta
          name="twitter:text:title"
          content="NTUNA.COM | Solutions | Digital Marketing & SEO"
        />
        <meta
          name="twitter:description"
          content="Attract the right audience, convert visitors into customers and grow your brand online with our SEO and digital marketing implementations and strategies"
        />
        <meta
          name="twitter:image"
          content="https://res.cloudinary.com/malidad/image/upload/v1779627082/ntuna_solutions_banner_1200x628_c8xerm.jpg"
        />
        <title>NTUNA.COM | Solutions | Digital Marketing & SEO</title>
      </Helmet>
      <SolutionItemHero
        title="Digital Marketing & Search Engine Optimization[SEO]"
        subtitle="Attract the right audience, convert visitors into customers, and grow your brand online with SEO, digital marketing and data-driven strategies that increase your brand's reach, traffic, leads and sales."
        casestudylink="/#"
        CTAtext="Get Free Quote"
        mainCTAlink="https://form.jotform.com/ntuna/get-free-quote"
      />
      <Authority />
      <DigitalMarketing />
      <SolutionCTA ctaTitle="Ready To Have Your Business's Digital Marketing Done Right?" />
      <DigitalMarketingFaqsBody />
      <SolutionCTA ctaTitle="Ready To Have Your Business's Digital Marketing Done Right?" />
      <HowWeWork />
      <SolutionCTA ctaTitle="Ready To Have Your Business's Digital Marketing Done Right?" />
      <RelatedDigitalMarketing />
    </>
  );
}
